import { Component, AfterViewInit, OnDestroy, Input, ViewChild, ElementRef, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { TenantService } from '../services/tenant.service';
import { UserService } from '../services';

declare var stripe: any;
declare var elements: any;

@Component({
    selector: 'credit-card-form',
    styles: [`
        form.card-etails {
            max-width: 500px;
            margin: 2rem auto;
            text-align: center;
            border: 2px solid #eee;
            border-radius: 8px;
            padding: 1rem 2rem;
            background: white;

            font-family: monospace;
            color: #525252;
            font-size: 1.1rem;
        }

        .StripeElement {
            margin: 1rem 0 1rem;
            background-color: white;
            padding: 8px 12px;
            border-radius: 4px;
            border: 1px solid transparent;
            box-shadow: 0 1px 3px 0 #e6ebf1;
            -webkit-transition: box-shadow 150ms ease;
            transition: box-shadow 150ms ease;
        }

        .StripeElement--focus {
            box-shadow: 0 1px 3px 0 #cfd7df;
        }

        .StripeElement--invalid {
            border-color: #fa755a;
        }

        .StripeElement--webkit-autofill {
            background-color: #fefde5 !important;
        }
    `],
    template: `
        <div style="margin:10px;">
            <form #checkout="ngForm" (ngSubmit)="subscribe()" class="card-details">
                <div class="form-row">
                    <div id="card-info" #cardInfo></div>
                    <div *ngIf="error" style="padding-bottom: 10px;">
                        <mat-error id="card-errors" role="alert">{{ error }}</mat-error>
                    </div>
                </div>

                <button mat-raised-button color="primary" [disabled]="addingCard" type="submit" type="submit">Save</button>
                <button *ngIf="!noCancel" mat-button [disabled]="addingCard" (click)="doCancel()" type="button">Cancel</button>
            </form>
        </div>
    `
})
export class CreditCardFormComponent implements AfterViewInit, OnDestroy  {
    @Input() noCancel : boolean;
    @Input() isUser: boolean;
    @Output() cardProcessed = new EventEmitter<null>();
    @Output() cancel = new EventEmitter<null>();

    @ViewChild('cardInfo', { static: true }) cardInfo: ElementRef;

    addingCard: boolean;

    card: any;
    error: string;

    cardHandler = this.onChange.bind(this);

    constructor(private cd: ChangeDetectorRef, 
                private tenantService: TenantService,
                private userService: UserService) {};

    clearError = () => this.error = null;

    doCancel = () => this.cancel.emit();

    async subscribe() {
        const { token, error } = await stripe.createToken(this.card);

        if (error) {
            this.error = token.error.message;
        } else {
            this.addingCard = true;
            (this.isUser ? this.userService.createPaymentMethod(token) : this.tenantService.createPaymentMethod(token))
            .subscribe(
                () => this.cardProcessed.emit(),
                (err) => {
                    this.addingCard = false;
                    this.error = `Error saving card: ${err.error.detail}`;
                }
            );
        }
    }

    ngAfterViewInit() {
        this.card = elements.create('card');
        this.card.mount(this.cardInfo.nativeElement);
        this.card.addEventListener('change', this.cardHandler);
    }

    ngOnDestroy() {
        this.card.removeEventListener('change', this.cardHandler);
        this.card.destroy();
    }

    onChange({ error }) {
        this.error = error ? error.message : null;
        this.cd.detectChanges();
    }
}
